<!--Copyright (C) nexleader - All Rights Reserved-->
<!--Unauthorized copying of this file, via any medium is strictly prohibited-->
<!--Proprietary and confidential-->
<!--Written for nexleader <myipsat.com>, 2016-2018-->

<!--
  V/§11.7 V-017b, 2026-06-26: dropped inline height/overflow chain and
  the intermediate `<div style="flex-grow: 1; …">` wrapper. The chain
  was a brute-force workaround for the V-017b height-cascade bug; the
  appendix now provides viewport-fill via `:has(> .content >
  app-nexleader-quick-view)` and a flex-column .content so the
  Export-to-CSV footer link sits below the quick-view automatically.
-->
<div id="nexleader-wrapper">
  <div class="content">
    <app-nexleader-quick-view
      [model]="users"
      [tableHeaders]="[
        'Name',
        'Email',
        'Coach',
        'Group',
        'Licensing Partner'
      ]"
      [tableColumns]="[
        '_name',
        'email',
        '_coach',
        '_group',
        '_licensingPartner'
      ]"
      [label]="'Users'"
      [overrideDisplayNewElement]="true"
      (onElementSelect)="selectedUser = $event"
    >
      <div *ngIf="selectedUser?._id; else notSelected">
        <app-nexleader-user-card
          [userId]="selectedUser._id"
          [currentViewingRole]="'admin'"
          (onChange)="load()"
        ></app-nexleader-user-card>
      </div>
      <ng-template #notSelected>
        <app-nexleader-quick-view-not-selected></app-nexleader-quick-view-not-selected>
      </ng-template>
    </app-nexleader-quick-view>
    <!-- TODO test export -->
    <a
      class="font-semi-bold text-muted"
      [href]="'/api/users/exportToCSV'"
      style="display: block; margin: 20px 0"
    >
      <i class="fa fa-share-square-o"></i>&nbsp;&nbsp;Export to CSV
    </a>
  </div>
</div>
